import { bynameAdjectivesShop, bynameAdjectivesShopNoCatalog, bynameSubjectsShop, bynameSubjectsShopNoCatalog } from "../../../Utils"

import { BynameAdjectiveString, BynameSubjectString } from "../../Byname/Byname"
import { BaseSeeds } from "./SeedListingLib"

export class BynameSeeds extends BaseSeeds {
    constructor(profileData, userData) {
        super("RewardRandomPool_Byname", profileData, userData)
    }

    evaluate_adjective(rng, adj) {
        if (adj.length === 0) {
            adj = [...bynameAdjectivesShop()]
        }
        const res = rng.get_u32() % adj.length
        const c = adj[res]
        adj.splice(res, 1)
        return `0000${c}`.slice(-4)
    }

    evaluate_subject(rng, sub) {
        if (sub.length === 0) {
            sub = [...bynameSubjectsShop()]
        }
        const res = rng.get_u32() % sub.length
        const c = sub[res]
        sub.splice(res, 1)
        return `0000${c}`.slice(-4)
    }

    advance_neutral(initial_seed) {
        initial_seed.get_u32()
    }

    get_start_adjectives() {
        const res = [...bynameAdjectivesShopNoCatalog()].filter(k => !(this.profileData.BynameAdjectiveMap[k] ?? false))
        return res
    }

    get_start_subjects() {
        const res = [...bynameSubjectsShopNoCatalog()].filter(k => !(this.profileData.BynameSubjectMap[k] ?? false))
        return res
    }

    get_have_adjectives() {
        const res = [...bynameAdjectivesShopNoCatalog()].filter(k => this.profileData.BynameAdjectiveMap[k] ?? false)
        return res
    }
    get_have_subjects() {
        const res = [...bynameSubjectsShopNoCatalog()].filter(k => this.profileData.BynameSubjectMap[k] ?? false)
        return res
    }

    get_have_adjectives_catalog() {
        const res = [...bynameAdjectivesShop()].filter(k => this.profileData.BynameAdjectiveMap[k] ?? false)
        return res
    }
    get_have_subjects_catalog() {
        const res = [...bynameSubjectsShop()].filter(k => this.profileData.BynameSubjectMap[k] ?? false)
        return res
    }

    get_start_adjectivesCatalog() {
        const res = [...bynameAdjectivesShop()].filter(k => !(this.profileData.BynameAdjectiveMap[k] ?? false))
        return res
    }
    get_start_subjectsCatalog() {
        const res = [...bynameSubjectsShop()].filter(k => !(this.profileData.BynameSubjectMap[k] ?? false))
        return res
    }

    singlePull() {
        const tmp = this.evaluate_adjective(this.rng, this.title_adj)
        const tmp2 = this.evaluate_subject(this.rng, this.title_sub)
        this.added_title_adj.push(tmp)
        this.added_title_sub.push(tmp2)
        return [tmp, tmp2]
    }

    setUpPull() {
        this.title_adj = this.get_start_adjectivesCatalog()
        this.title_sub = this.get_start_subjectsCatalog()
        this.added_title_adj = []
        this.added_title_sub = []
    }

    add_to_list(potential_seeds, current_state, entries) {
        const adj_list = entries.map(entry => entry.ValueAdj.raw)
        const sub_list = entries.map(entry => entry.ValueSub.raw)
        potential_seeds.push([current_state.get_clone(), adj_list, sub_list])
    }

    estimate_pulls() {
        return this.get_start_adjectives().length
    }

    estmiate_start_pulls() {
        return this.get_have_adjectives().length * 2 - 5
    }

    estimate_start() {
        return this.get_have_adjectives().length * 2 - 5
    }

    estimate_end() {
        return (this.get_start_adjectivesCatalog().length - this.get_start_adjectives().length + 5) * 2
    }

    seed_fits(current_state, entries) {
        const adj = this.get_start_adjectivesCatalog()
        const sub = this.get_start_subjectsCatalog()
        for (var entry of entries) {
            const tmp = this.evaluate_adjective(current_state, adj)
            const tmp2 = this.evaluate_subject(current_state, sub)
            if (parseInt(tmp) !== parseInt(entry.ValueAdj.raw) || parseInt(tmp2) !== parseInt(entry.ValueSub.raw)) {
                return false
            }
        }
        return true
    }

    calculateResultHandler(currentSeed) {
        const res = []
        this.setUpPull()
        this.init_rng(currentSeed)
        for (let results = 0; results < this.estimate_pulls(); results++) {
            const [tmp, tmp2] = this.singlePull()
            res.push({
                Idx: results + 1,
                Part1: <BynameAdjectiveString num={tmp} formless={true} />,
                Part2: <BynameSubjectString num={tmp2} formless={true} />,
                Raw1: [...this.added_title_adj],
                Raw2: [...this.added_title_sub],
                Seed: this.format_state(this.rng.get_state()),
                RawSeed: this.rng.get_state(),
                Update: true,
            })
        }
        return res
    }
}
